import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import * as Icons from '../icons';

export interface ProgressFieldProps {
  title: string;
  inProgress: boolean;
  started?: boolean;
  inProgressLabel?: string;
  doneLabel?: string;
  inProgressIcon?: ReactNode;
  doneIcon?: ReactNode;
}

interface ProgressIconProps {
  started: boolean;
  inProgress: boolean;
  inProgressIcon?: ReactNode;
  doneIcon?: ReactNode;
}

function ProgressIcon({ started, inProgress, inProgressIcon, doneIcon }: ProgressIconProps) {
  if (!started) {
    return (
      <Box height="32px">
        <Typography variant="h3">--</Typography>
      </Box>
    );
  } else if (inProgress) {
    return inProgressIcon ?? <CircularProgress variant="indeterminate" color="info" size="32px" />;
  } else {
    return doneIcon ?? <Icons.CheckCircleOutline color="success" sx={{ fontSize: '32px' }} />;
  }
}

export const ProgressField = ({
  title,
  inProgress,
  started = true,
  inProgressLabel,
  doneLabel,
  inProgressIcon,
  doneIcon,
}: ProgressFieldProps) => {
  const { t } = useTranslation('programWizard');

  return (
    <Stack alignItems="center" spacing={1}>
      <ProgressIcon started={started} inProgress={inProgress} inProgressIcon={inProgressIcon} doneIcon={doneIcon} />
      <Typography variant="h4" aria-label={`progress of ${title} process`}>
        {title}
      </Typography>
      {started && (
        <Typography variant="body2" color="text.secondary">
          {inProgress ? (inProgressLabel ?? t('starting.inProgress')) : (doneLabel ?? t('starting.done'))}
        </Typography>
      )}
    </Stack>
  );
};
